import React, { FC, useContext, useEffect, useRef } from 'react';
import styles from './toast.module.css';

// Providers
import {
  GeneralContext,
  initialToastContent,
} from '../../providers/general-provider';

const Toast: FC<{ content: ToastContent }> = ({ content }) => {
  const { setToastContent } = useContext(GeneralContext);
  const isOpenPreviousRef = useRef(false);

  useEffect(() => {
    if (!isOpenPreviousRef.current && content.isOpen) {
      setTimeout(() => {
        setToastContent(initialToastContent);
        isOpenPreviousRef.current = false;
      }, 3000);
    } else {
      isOpenPreviousRef.current = content.isOpen;
    }
  }, [content.isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  let backgroundColor: string;
  let smileType: string;
  switch (content.type) {
    case 'success':
      backgroundColor = styles.successBackground;
      smileType = styles.successSmile;
      break;
    case 'error':
      backgroundColor = styles.successBackground;
      smileType = styles.failSmile;
      break;
    default:
      backgroundColor = styles.successBackground;
      smileType = styles.successSmile;
      break;
  }

  const stateClass = content.isOpen ? styles.toastOpen : styles.toastClose;
  return (
    <div
      className={[styles.toastContainer, backgroundColor, stateClass].join(' ')}
    >
      <div className={smileType}></div>
      <p>{content.text}</p>
    </div>
  );
};

export default Toast;
